import './utils/sentry';

import './main.css';

// import './utils/animations';
import './utils/discounts';
import * as tracking from './utils/tracking';

import './dialogs/DialogCart';
import './dialogs/DialogEsimCheck';
import './dialogs/DialogNav';
import './dialogs/DialogQuiz';
import './dialogs/DialogSim';
import './dialogs/DialogZipCoverage';

import './components/CartCounter';
import './components/CartDrawer';
import './components/CartItem';
import './components/CartPage';
import './components/Countdown';
import './components/CtaWrapper';
import './components/CustomDropdown';
import './components/FaqItem';
import './components/FixedAtc';
import './components/OnpageNav';
import './components/PhoneForm';
import './components/PlanLabel';
import './components/PlanQuiz';
import './components/PlanQuizQuestion';
import './components/PlanQuizResults';
import './components/PlansSlider';
import './components/ProductForm';
import './components/ProductGallery';
import './components/ProductListingPrice';
import './components/ProductPrice';
import './components/ProductSlider';
import './components/SimCheck';
import './components/TestimonialsSlider';
import './components/VideoPlayer';
import './components/ZipCoverage';

tracking.init();
